import React from 'react';
import possibilityImage from '../../assets/ds.png';
import './possibility.css';

const Possibility = () => (
  <div className="yellow__possibility section__padding" id="possibility">
    <div className="yellow__possibility-image">
      <img src={possibilityImage} alt="possibility" />
    </div>
    <div className="yellow__possibility-content">
      <h4>Request Early Access to Get Started</h4>
      <h1 className="gradient__text">The possibilities are <br /> beyond your imagination</h1>
      <p>Beyond environmental impact, our data-driven recycling and waste management technology offers substantial economic and social benefits. For municipalities, optimized waste collection routes and efficient recycling processes translate to significant cost savings. These savings can be redirected to other critical areas, enhancing overall community welfare. Furthermore, the implementation and maintenance of advanced waste management technologies create job opportunities, stimulating local economies. The combination of cost savings, job creation, and enhanced community engagement underscores the multifaceted value of our approach.</p>
      <h4>Request Early Access to Get Started</h4>
    </div>
  </div>
);

export default Possibility;